(function () {
  const productsFilters = (root = document) => {
    const wrapper = root.querySelector('.popular-products__wrapper');
    if (!wrapper) return;

    const products = root.querySelectorAll('.popular-products .collection-popular-card');
    const limit = Number(wrapper.dataset.limit || 0);

    root.querySelectorAll('.filters__item').forEach((item) => {
      item.addEventListener('click', () => {
        const filterTarget = item.dataset.filterTarget;

        root.querySelectorAll('.filters__item').forEach((el) =>
          el.classList.remove('filters__item_active')
        );
        item.classList.add('filters__item_active');

        let shown = 0;
        products.forEach((el) => el.classList.remove('show'));

        products.forEach((el) => {
          if (shown >= limit) return;

          let productFilter = [];
          try {
            productFilter = JSON.parse(el.dataset.filter || '[]');
          } catch (e) {
            productFilter = [];
          }

          const match =
            filterTarget === 'all' ||
            productFilter.some((f) => f === filterTarget);

          if (match && shown < limit) {
            el.classList.add('show');
            shown += 1;
          } else {
            el.classList.remove('show');
          }
        });
      });
    });
  };

  function initCountdown(root = document) {
    const blocks = root.querySelectorAll('.popular-products__countdown');
    if (!blocks.length) return;

    blocks.forEach((block) => {
      const startRaw = (block.getAttribute('data-countdown-start') || '').trim();
      const endRaw = (block.getAttribute('data-countdown-end') || '').trim();

      const startTs = startRaw ? Date.parse(startRaw) : NaN;
      const endTs = endRaw ? Date.parse(endRaw) : NaN;

      const labelEl = block.querySelector('[data-countdown-label]');
      const timerEl = block.querySelector('[data-countdown-timer]');
      if (!timerEl) return;

      if (block._countdownInterval) clearInterval(block._countdownInterval);

      function pad(num) {
        return num < 10 ? '0' + num : String(num);
      }

      function formatDiff(diffMs) {
        const totalSeconds = Math.floor(diffMs / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        return (
          days + 'd ' +
          pad(hours) + 'h ' +
          pad(minutes) + 'm ' +
          pad(seconds) + 's'
        );
      }

      function updateCountdown() {
        const now = Date.now();

        // Decide which target we are counting toward
        let mode = 'end'; // 'start' or 'end'
        let targetTs = endTs;

        // If start is provided and we haven't started yet -> countdown to start
        if (!Number.isNaN(startTs) && now < startTs) {
          mode = 'start';
          targetTs = startTs;
        }

        // If end is invalid, stop
        if (Number.isNaN(targetTs)) {
          console.warn('[popular-products] Invalid countdown date(s):', { startRaw, endRaw });
          timerEl.textContent = '';
          return;
        }

        // If counting to end but end already passed -> ended
        if (mode === 'end' && !Number.isNaN(endTs) && now >= endTs) {
          if (labelEl) labelEl.textContent = 'Ends in:';
          timerEl.textContent = 'Sale ended';
          clearInterval(block._countdownInterval);
          return;
        }

        // Label
        if (labelEl) labelEl.textContent = mode === 'start' ? 'Starts in:' : 'Ends in:';

        const diff = targetTs - now;
        if (diff <= 0) {
          timerEl.textContent = mode === 'start' ? 'Starting now' : 'Sale ended';
          return;
        }

        timerEl.textContent = formatDiff(diff);
      }

      updateCountdown();
      block._countdownInterval = setInterval(updateCountdown, 1000);
    });
  }

  async function initDynamicPromotionForSection(popularRoot) {
    if (!popularRoot) return;

    const enabled = (popularRoot.dataset.dynamicPromo || '') === 'true';
    if (!enabled) return;

    // prevent multiple calls
    if (popularRoot.dataset.promoLoaded === '1') return;
    popularRoot.dataset.promoLoaded = '1';

    const apiUrl = (popularRoot.dataset.promoApi || '').trim();
    if (!apiUrl) return;

    try {
      const res = await fetch(apiUrl, { cache: 'no-store' });
      if (!res.ok) return;

      const json = await res.json();
      console.log("Raw: ", json);
      if (!json || json.ok === false) return;

      // 1) heading
      const headingEl = popularRoot.querySelector('[data-heading]');
      if (headingEl && json.title) headingEl.textContent = json.title;
      console.log("Title: ", json.title);

      // 2) countdown + hide/show products based on window
      const countdown = popularRoot.querySelector('[data-countdown-wrapper]');
      const wrapper = popularRoot.querySelector('.popular-products__wrapper');

      const start = (json.countdown_start || '').trim();
      const end = (json.countdown_end || '').trim();

      if (countdown) {
        countdown.setAttribute('data-countdown-start', start);
        if (end) countdown.setAttribute('data-countdown-end', end);
        initCountdown(popularRoot);
      }

      // Decide if promo is active NOW
      let activeNow = true;
      const now = Date.now();

      const startTs = start ? Date.parse(start) : NaN;
      const endTs = end ? Date.parse(end) : NaN;

      if (!Number.isNaN(startTs) && now < startTs) activeNow = false;
      if (!Number.isNaN(endTs) && now >= endTs) activeNow = false;

      // If promotion not occurring -> hide product list (or entire section)
      if (!activeNow) {
        if (wrapper) wrapper.style.display = 'none';
        // Optional: also hide filters so it looks clean
        const filters = popularRoot.querySelector('.popular-products__filters');
        if (filters) filters.style.display = 'none';
      } else {
        if (wrapper) wrapper.style.display = '';
        const filters = popularRoot.querySelector('.popular-products__filters');
        if (filters) filters.style.display = '';
      }

      // 3) filter click
      if (activeNow) {
        const filterValue = (json.filter_value || '').trim();
        if (filterValue) {
          const btn = popularRoot.querySelector(
            `.filters__item[data-filter-target="${CSS.escape(filterValue)}"]`
          );
          if (btn) btn.click();
        }
      }
    } catch (e) {
      console.warn('[popular-products] dynamic promo fetch failed:', e);
    }
  }

  function initSection(root = document) {
    const popularSections = root.querySelectorAll('.popular-products');
    if (!popularSections.length) return;

    popularSections.forEach((section) => {
      productsFilters(section);
      initCountdown(section);
      initDynamicPromotionForSection(section);
    });
  }

  // Initial storefront load
  document.addEventListener('DOMContentLoaded', function () {
    initSection(document);
  });

  // Shopify theme editor reload
  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target;
    if (!section.matches('.popular-products-section')) return;
    initSection(section);
  });
})();

